<script>
import main from '@cm-frontend/commons/src/maker/vue-files/main';
export default {
  extends: main,
  metaInfo: {
    title: 'GameMaker',
    titleTemplate: '%s - Codementum'
  }
};
</script>
